/* My Pure Herb — site updates (29 Sep 2026). Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var store = {
    get: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Product gallery: arrows, swipe, keyboard, counter ---------- */
  function initGallery(stage) {
    if (stage._mph) return;
    stage._mph = true;
    var root = stage.closest('[data-gallery]');
    if (!root) return;
    var thumbs = $$('[data-thumb]', root);
    if (thumbs.length < 2) return;
    var strip = $('.product__thumbs', root);
    var counter = $('[data-gallery-count]', stage);

    function current() {
      for (var i = 0; i < thumbs.length; i++) if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    }
    function preload(i) {
      var t = thumbs[(i + thumbs.length) % thumbs.length];
      if (t && !t._pre) { t._pre = true; var im = new Image(); im.src = t.getAttribute('data-src'); }
    }
    function sync(i) {
      if (counter) counter.textContent = (i + 1) + ' / ' + thumbs.length;
      var t = thumbs[i];
      if (strip && t) {
        var left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      preload(i + 1); preload(i - 1);
    }
    function go(i) {
      i = (i + thumbs.length) % thumbs.length;
      thumbs[i].click(); // the theme's own handler swaps the main image
    }
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-thumb]');
      if (th) window.setTimeout(function () { sync(thumbs.indexOf(th)); }, 0);
    });
    var prev = $('[data-gallery-prev]', stage), next = $('[data-gallery-next]', stage);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
    });
    var sx = 0, sy = 0, tracking = false;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) go(current() + (dx < 0 ? 1 : -1));
    }, { passive: true });
    sync(current());
  }
  $$('[data-gallery-stage]').forEach(initGallery);

  /* ---------- Shoppable reels: muted autoplay while on screen, tap to shop ---------- */
  function initReels(section) {
    if (section._mph) return;
    section._mph = true;
    var cards = $$('[data-reel]', section);
    if (!cards.length) return;
    var conn = navigator.connection || {};
    var saveData = !!conn.saveData;
    var slow = /(^|-)2g|3g/.test(conn.effectiveType || '');
    var auto = !reduceMotion && !saveData;
    function vid(c) { return $('[data-reel-video]', c); }
    // Pick the file size for the screen: a desktop row of 4+ reels and slow connections get 480p,
    // phones get 720p or (on large sharp screens) 1080p. Only one size is ever downloaded per reel.
    var track0 = $('[data-reels-track]', section);
    function rowCount() {
      if (!track0) return 1;
      var t = track0.getBoundingClientRect();
      return cards.filter(function (c) { var r = c.getBoundingClientRect(); return r.left >= t.left - 2 && r.right <= t.right + 2; }).length;
    }
    function pick(v) {
      var md = v.getAttribute('data-src'), sd = v.getAttribute('data-src-sd'), hd = v.getAttribute('data-src-hd');
      if (slow) return sd || md;
      var px = v.getBoundingClientRect().width * (window.devicePixelRatio || 1);
      if (sd && (rowCount() >= 4 || (px && px <= 320))) return sd;
      if (hd && px > 560) return hd;
      return md || hd || sd;
    }
    function load(v) {
      if (!v || v._loaded) return;
      var src = pick(v);
      if (src) { v._loaded = true; v.src = src; }
    }
    function setToggle(c, paused) {
      var b = $('[data-reel-toggle]', c);
      if (b) { b.setAttribute('aria-pressed', String(paused)); b.setAttribute('aria-label', paused ? 'Play video' : 'Pause video'); }
    }
    function play(c) {
      var v = vid(c);
      if (!v || c._userPaused) return;
      load(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () { setToggle(c, true); });
      setToggle(c, false);
    }
    function pause(c) { var v = vid(c); if (v && !v.paused) v.pause(); }
    cards.forEach(function (c) {
      var v = vid(c);
      if (!v) return;
      v.muted = true;
      if (!auto) { c._userPaused = true; setToggle(c, true); }
      var t = $('[data-reel-toggle]', c), s = $('[data-reel-sound]', c);
      if (t) t.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (v.paused) { c._userPaused = false; play(c); }
        else { c._userPaused = true; v.pause(); setToggle(c, true); }
      });
      if (s) s.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var turnOn = v.muted;
        cards.forEach(function (o) {
          if (o === c) return;
          var ov = vid(o), ob = $('[data-reel-sound]', o);
          if (ov) ov.muted = true;
          if (ob) { ob.setAttribute('aria-pressed', 'false'); ob.setAttribute('aria-label', 'Turn sound on'); }
        });
        v.muted = !turnOn;
        s.setAttribute('aria-pressed', String(turnOn));
        s.setAttribute('aria-label', turnOn ? 'Turn sound off' : 'Turn sound on');
        if (turnOn) { c._userPaused = false; play(c); }
      });
    });
    if ('IntersectionObserver' in window) {
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { if (auto) load(vid(en.target)); near.unobserve(en.target); } });
      }, { rootMargin: '300px 0px' });
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.intersectionRatio >= 0.6) { if (auto) play(en.target); } else pause(en.target); });
      }, { threshold: [0, 0.6] });
      cards.forEach(function (c) { if (vid(c)) { near.observe(c); seen.observe(c); } });
    } else if (auto) { cards.forEach(play); }
    document.addEventListener('visibilitychange', function () { if (document.hidden) cards.forEach(pause); });

    // Arrows for the row (shown only when the row is wider than the screen)
    var track = $('[data-reels-track]', section), prev = $('[data-reels-prev]', section), next = $('[data-reels-next]', section);
    if (track && prev && next) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var max = track.scrollWidth - track.clientWidth;
        var over = max > 4;
        prev.hidden = next.hidden = !over;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= max - 4;
      };
      var step = function (dir) {
        var card = $('.reel-card', track);
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
        var w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        var n = Math.max(1, Math.floor((track.clientWidth + gap) / w));
        track.scrollBy({ left: dir * w * n, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }
  $$('[data-reels]').forEach(initReels);

  /* ---------- Scrolling announcement: same reading speed on every screen ---------- */
  function initMarquee(m) {
    if (m._mph) return;
    m._mph = true;
    var track = $('.marquee__track', m), group = $('.marquee__group', m);
    if (!track || !group) return;
    var speed = parseFloat(m.getAttribute('data-speed')) || 45;
    var set = function () {
      var w = group.getBoundingClientRect().width;
      if (w > 0) track.style.setProperty('--marquee-duration', Math.round(w / speed) + 's');
    };
    set();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(set);
    var t;
    window.addEventListener('resize', function () { window.clearTimeout(t); t = window.setTimeout(set, 200); });
  }
  $$('[data-marquee]').forEach(initMarquee);

  /* ---------- Header: soft shadow once the page scrolls ---------- */
  var hdr = $('[data-header]');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Hero: fetch the other slides after the page has loaded (no blank flash) ---------- */
  window.addEventListener('load', function () {
    $$('.hero__slide img[loading="lazy"]').forEach(function (img) { if (img.offsetParent !== null) img.loading = 'eager'; });
  });

  /* ---------- Activity / discovery pop-ups ---------- */
  function initActivity() {
    var el = $('[data-activity-toast]'), json = $('[data-activity-json]');
    if (!el || !json || el._mph) return;
    el._mph = true;
    var cfg;
    try { cfg = JSON.parse(json.textContent); } catch (e) { return; }
    var path = window.location.pathname.replace(/\/$/, '');
    var items = (cfg.items || []).filter(function (it) { return it && it.url && it.url.replace(/\/$/, '') !== path; });
    if (!items.length) return;
    if (!cfg.mobile && window.matchMedia('(max-width: 749px)').matches) return;
    if (store.get('mph_activity_off') === '1') return;
    if (window.Shopify && window.Shopify.designMode) return;

    var shown = parseInt(store.get('mph_activity_count') || '0', 10);
    var idx = parseInt(store.get('mph_activity_idx') || String(Math.floor(Math.random() * items.length)), 10) % items.length;
    var hideTimer = null, nextTimer = null, paused = false;

    function busy() {
      return document.hidden || !!$('.cart-drawer.is-open, .mnav.is-open, .search-modal.is-open, dialog[open]');
    }
    // Never sit on top of an Add to cart / Buy button
    function coversButtons() {
      var mobile = window.innerWidth < 750;
      var sticky = $('.sticky-buy.is-on');
      var bottom = sticky ? sticky.offsetHeight + 12 : 16;
      var h = el.offsetHeight || 76;
      var zone = { top: window.innerHeight - bottom - h - 8, bottom: window.innerHeight - bottom + 4, left: mobile ? 0 : 0, right: mobile ? window.innerWidth : Math.min(372, window.innerWidth) };
      return $$('[data-add-btn], [data-dynamic-checkout], .product__buy button, .card__cta .btn, .card__cta button, .cart-drawer button[type=submit]').some(function (b) {
        var r = b.getBoundingClientRect();
        if (!r.width || !r.height) return false;
        return r.bottom > zone.top && r.top < zone.bottom && r.right > zone.left && r.left < zone.right;
      });
    }
    function place() {
      var sticky = $('.sticky-buy.is-on');
      el.style.setProperty('--activity-bottom', sticky ? (sticky.offsetHeight + 12) + 'px' : '1rem');
    }
    function hide() {
      el.classList.remove('is-on');
      window.setTimeout(function () { if (!el.classList.contains('is-on')) el.hidden = true; }, 320);
    }
    function schedule(ms) {
      window.clearTimeout(nextTimer);
      if (shown >= cfg.maxPerVisit || store.get('mph_activity_off') === '1') return;
      nextTimer = window.setTimeout(show, ms);
    }
    function show() {
      if (busy() || coversButtons()) { schedule(6000); return; }
      var it = items[idx % items.length];
      idx = (idx + 1) % items.length;
      store.set('mph_activity_idx', String(idx));
      $('[data-activity-link]', el).setAttribute('href', it.url);
      $('[data-activity-kicker]', el).textContent = it.kicker || '';
      $('[data-activity-title]', el).textContent = it.title || '';
      $('[data-activity-text]', el).textContent = it.text || '';
      var imgWrap = $('[data-activity-img]', el);
      imgWrap.innerHTML = '';
      if (it.img) { var im = new Image(); im.src = it.img; im.alt = ''; im.width = 52; im.height = 52; imgWrap.appendChild(im); }
      place();
      el.hidden = false;
      window.requestAnimationFrame(function () { el.classList.add('is-on'); });
      shown += 1;
      store.set('mph_activity_count', String(shown));
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () { if (!paused) { hide(); schedule(cfg.interval); } }, cfg.visible);
    }
    el.addEventListener('mouseenter', function () { paused = true; window.clearTimeout(hideTimer); });
    el.addEventListener('mouseleave', function () {
      paused = false;
      hideTimer = window.setTimeout(function () { hide(); schedule(cfg.interval); }, 2500);
    });
    $('[data-activity-close]', el).addEventListener('click', function () {
      store.set('mph_activity_off', '1');
      window.clearTimeout(nextTimer); window.clearTimeout(hideTimer);
      hide();
    });
    window.addEventListener('scroll', function () {
      if (el.hidden) return;
      place();
      if (el.classList.contains('is-on') && coversButtons()) { window.clearTimeout(hideTimer); hide(); schedule(cfg.interval); }
    }, { passive: true });
    schedule(cfg.firstDelay);
  }
  initActivity();

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-gallery-stage]', e.target).forEach(initGallery);
    $$('[data-reels]', e.target).forEach(initReels);
    $$('[data-marquee]', e.target).forEach(initMarquee);
  });
})();